import type { DashboardData } from '@/hooks/dashboardDataTypes'

export function mapSummaryData(data: DashboardData) {
  if (!data.summary) return null
  return {
    totalLeads: data.summary.totalLeads,
    totalDeals: data.summary.totalDeals,
    pipelineValue: data.summary.pipelineValue,
    pipelineCount: data.summary.pipelineCount,
    wonRevenue: data.summary.receitaMensal,
    wonDeals: data.summary.dealsFechadosMes,
    lostDeals: data.summary.lostDeals,
    winRate: data.summary.taxaConversao,
    dealsByStage: data.summary.dealsByStage,
    topPerformers: [],
  }
}

export function mapSalesData(data: DashboardData) {
  if (!data.sales) return null
  return {
    totalRevenue: data.sales.totalRevenue,
    totalWon: data.sales.totalWon,
    avgTicket: data.sales.avgTicket,
    totalMonthly: data.sales.totalMonthly ?? 0,
    totalSetup: data.sales.totalSetup ?? 0,
    avgMonthly: data.sales.avgMonthly ?? 0,
    byType: data.sales.byType ?? [],
    closedDeals: data.sales.closedDeals ?? [],
    monthlyData: data.sales.monthlyData,
  }
}

export function mapBdrData(data: DashboardData) {
  if (!data.bdr) return null
  return {
    totalLeads: data.bdr.totalLeads,
    convertedLeads: data.bdr.convertedLeads,
    conversionRate: data.bdr.conversionRate,
    leadsByStatus: data.bdr.leadsByStatus,
  }
}

export function mapCommissionsData(data: DashboardData) {
  if (!data.commissions) return null
  const pending = data.commissions.byStatus.find((s) => s.status === 'PENDENTE')
  const approved = data.commissions.byStatus.find((s) => s.status === 'APROVADO')
  const paid = data.commissions.byStatus.find((s) => s.status === 'PAGO')
  return {
    totalPending: pending?.totalCentavos ? pending.totalCentavos / 100 : 0,
    totalApproved: approved?.totalCentavos ? approved.totalCentavos / 100 : 0,
    totalPaid: paid?.totalCentavos ? paid.totalCentavos / 100 : 0,
    commissions: data.commissions.topBeneficiaries.map((b) => ({
      id: b.userId,
      sellerName: b.name,
      dealTitle: 'Comissão',
      dealValue: b.totalCentavos / 100,
      rate: 0,
      commissionValue: b.totalCentavos / 100,
      status: 'pendente' as const,
      createdAt: '',
    })),
  }
}

export function mapAdminData(data: DashboardData) {
  if (!data.admin) return null
  return {
    totalBdrs: data.admin.totalBdrs,
    totalClosers: data.admin.totalClosers,
    dealsPerMonth: data.admin.dealsPerMonth,
    teamMembers: data.admin.teamMembers,
    pipelineByCloser: data.admin.pipelineByCloser,
    monthlyGoal: data.admin.monthlyGoal,
    monthlyAchieved: data.admin.monthlyAchieved,
  }
}

export function mapRetentionData(data: DashboardData) {
  if (!data.retention) return null
  return {
    totalAccounts: data.retention.totalAccounts,
    churnRate: data.retention.churnRate,
    npsAvg: data.retention.npsAvg,
    mrrTotal: data.retention.mrrTotal,
    greenCount: data.retention.greenCount,
    yellowCount: data.retention.yellowCount,
    redCount: data.retention.redCount,
    healthScoresAvailable: data.retention.healthScoresAvailable,
    message: data.retention.message,
    accounts: data.retention.accounts,
  }
}

export function mapOpsHealthData(data: DashboardData) {
  if (!data.opsHealth) return null
  return {
    available: data.opsHealth.available,
    placeholder: data.opsHealth.placeholder,
    message: data.opsHealth.message,
    slaCompliance: data.opsHealth.slaCompliance,
    avgResponseTime: data.opsHealth.avgResponseTime,
    systemUptime: data.opsHealth.systemUptime,
    activeAlerts: data.opsHealth.activeAlerts,
    tasksCompletedToday: data.opsHealth.tasksCompletedToday,
    tasksTotalToday: data.opsHealth.tasksTotalToday,
    overdueTasks: data.opsHealth.overdueTasks,
    metrics: data.opsHealth.metrics,
  }
}
